/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
export enum EntityType {
    ACTION = "ACTION",
    ASSET = "ASSET",
    EVENT = "EVENT",
    LOCATION = "LOCATION",
    READZONE = "READZONE",
    READER = "READER",
    ANTENNA = "ANTENNA",
    OBJECT = "OBJECT",
    USER = "USER",
    GROUP = "GROUP",
    RULE = "RULE",
    DIALOG = "DIALOG",
    SERVICE = "SERVICE",
    SERVEROBJECT = "SERVEROBJECT",
    DRIVEROBJECT = "DRIVEROBJECT"
}
